import { smStyle } from '@/components/Adapter'
import { Flex } from '@mantine/core'
import styled from 'styled-components'

export const CurrencyStyled = styled(Flex)`
  height: 80px;
  padding: 1px 0;
  box-sizing: border-box;

  .price-currency-favorite {
    color: var(--color-icon-5);
  }
`

export const CoinStyled = styled.a`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  height: 100%;

  &[data-new='true'] {
    background: #f2b80c1a;
    padding: 0 8px 0 4px;
    margin-left: -4px;

    ${smStyle} {
      padding: 0 16px 0 8px;
      margin-left: -8px;
    }
  }

  .currency-price {
    max-width: 120px;

    ${smStyle} {
      max-width: 200px;
    }
  }

  &:hover span {
    color: var(--color-brand-1) !important;
  }
`
